import { Modal, Space, Text } from '@procurify/ui'

import { TextLoader } from '@webapp/core/components/ContentLoader'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CardPinModalStyled } from './styles/CardPinModalStyled'

export interface ICardPinModalProps {
  open: boolean
  onClose: () => void
  iframeUrl: string | undefined
}

export const CardPinModal = ({
  open,
  onClose,
  iframeUrl,
}: ICardPinModalProps) => {
  const intl = useProcurifyIntl()

  const showLoader = !iframeUrl

  return (
    <Modal open={open} onClose={onClose} maxWidth='xs'>
      <Modal.Card>
        <Modal.Header onClose={onClose}>
          {intl.formatMessage(messages.modalHeaderText)}
        </Modal.Header>

        <Modal.Content>
          <CardPinModalStyled>
            <Space align='center'>
              <Space.Item width={1}>
                <Text>{intl.formatMessage(messages.descriptionText1)}</Text>
              </Space.Item>

              {showLoader ? (
                <TextLoader width={100} />
              ) : (
                <iframe
                  title={intl.formatMessage(messages.iframeLabel)}
                  aria-label={intl.formatMessage(messages.iframeLabel)}
                  src={iframeUrl}
                />
              )}

              <Space.Item width={1}>
                <Text>{intl.formatMessage(messages.descriptionText2)}</Text>
              </Space.Item>
            </Space>
          </CardPinModalStyled>
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
